import { ChangeDetectionStrategy, Component, Inject, inject, OnInit } from '@angular/core'

import { filter, map, takeUntil } from 'rxjs'

import { DestroyDirective } from '~/core/directives'
import { COMPANY_FACADE, ICompanyFacade } from '~/core/features'
import { LoadingComponent } from '~/ui/loading'

@Component({
  selector: 'app-historical-data-container',
  template: `
    @defer (on immediate) {
      <!-- <app-forecast-historical-chart></app-forecast-historical-chart> -->
    } @loading {
      <app-loading class="loading"></app-loading>
    }
  `,
  styleUrl: './historical-data-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [LoadingComponent],
})
export class HistoricalDataContainerComponent implements OnInit {
  private readonly destroy$ = inject(DestroyDirective).destroy$

  constructor(@Inject(COMPANY_FACADE) public companyFacade: ICompanyFacade) {}

  ngOnInit(): void {
    this.companyFacade.forecast$
      .pipe(
        takeUntil(this.destroy$),
        filter(forecast => Boolean(forecast)),
        map(forecast => forecast!.company.companyId)
      )
      .subscribe(companyId => {
        this.companyFacade.getContourData(companyId)
        this.companyFacade.getImpactIsolines(companyId)
      })
  }
}
